(function () {
  var follow = document.querySelector('[data-follow]');
  if (!follow) return;

  var btn = follow.querySelector('.sn-follow__can');
  var wrap = follow.querySelector('.sn-follow__can-wrap');
  var stations = follow.querySelectorAll('[data-station]');
  var hint = follow.querySelector('.sn-follow__hint');
  var crackCtas = follow.querySelectorAll('[data-crack-cta]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cracked = false;
  var activeStation = null;

  var setHint = function (open) {
    if (!hint) return;
    if (open) {
      hint.textContent = 'there it is.';
      return;
    }
    var clickEl = document.createElement('span');
    var tapEl = document.createElement('span');
    clickEl.className = 'sn-follow__hint-click';
    tapEl.className = 'sn-follow__hint-tap';
    clickEl.textContent = hint.getAttribute('data-hint-click') || '';
    tapEl.textContent = hint.getAttribute('data-hint-tap') || '';
    hint.replaceChildren(clickEl, tapEl);
  };

  var crackOpen = function () {
    if (cracked) return;
    cracked = true;
    follow.classList.add('is-shake');
    if (!reduce) {
      window.setTimeout(function () {
        follow.classList.add('is-cracked');
        follow.classList.remove('is-shake');
      }, 180);
    } else {
      follow.classList.add('is-cracked');
      follow.classList.remove('is-shake');
    }
    if (btn) {
      btn.setAttribute('aria-expanded', 'true');
      btn.setAttribute('aria-label', 'mango passion can');
    }
    setHint(true);
  };

  var sealCan = function () {
    cracked = false;
    follow.classList.remove('is-cracked', 'is-shake');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    setHint(false);
  };

  if (btn) {
    btn.style.pointerEvents = 'none';
  }

  crackCtas.forEach(function (cta) {
    cta.addEventListener('click', function () {
      crackOpen();
    });
  });

  var applyStation = function (el) {
    if (!el) return;
    var station = el.getAttribute('data-station') || 'meet';
    var step = el.getAttribute('data-step') || '01';
    el.classList.add('is-inview');

    if (activeStation === station) return;
    activeStation = station;
    follow.setAttribute('data-now', station);
    follow.setAttribute('data-level', String(parseInt(step, 10) || 1));
  };

  var syncStation = function () {
    var mid = window.innerHeight * 0.45;
    var best = null;
    var bestDist = Infinity;
    stations.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 80 || rect.top > window.innerHeight - 40) return;
      var center = rect.top + rect.height / 2;
      var dist = Math.abs(center - mid);
      if (dist < bestDist) {
        bestDist = dist;
        best = el;
      }
    });
    if (best) applyStation(best);
  };

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('is-inview');
        });
        syncStation();
      },
      { threshold: [0.15, 0.35, 0.55, 0.75], rootMargin: '0px 0px -10% 0px' }
    );
    stations.forEach(function (station) { io.observe(station); });
  } else {
    stations.forEach(function (station) { station.classList.add('is-inview'); });
  }

  var typeStation = follow.querySelector('[data-station="type"]');
  var typeCta = typeStation
    ? typeStation.querySelector('.sn-chat__cta') || typeStation.querySelector('.sn-follow__chip')
    : null;

  var typeExitProgress = function () {
    if (!typeStation) return 0;
    var viewH = window.innerHeight || 1;
    var bottom = typeStation.getBoundingClientRect().bottom;
    var pin = follow.querySelector('.sn-follow__pin');
    var pinBottom = pin ? pin.getBoundingClientRect().bottom : viewH * 0.42;
    /* Stay for the whole blue chat. Leave only once that section has passed the can. */
    var start = pinBottom + viewH * 0.06;
    var end = Math.max(64, pinBottom - viewH * 0.22);
    if (bottom >= start) return 0;
    if (bottom <= end) return 1;
    return (start - bottom) / (start - end);
  };

  var smooth = function (t) {
    t = Math.min(1, Math.max(0, t));
    return t * t * t * (t * (t * 6 - 15) + 10);
  };

  /* Softer than smootherstep, so the middle of the phone dock doesn't whip. */
  var glide = function (t) {
    t = Math.min(1, Math.max(0, t));
    var s = t * t * (3 - 2 * t);
    return s * 0.45 + t * 0.55;
  };

  /* Mostly even zoom, with a soft start and finish. */
  var scaleEase = function (t) {
    t = Math.min(1, Math.max(0, t));
    var s = t * t * (3 - 2 * t);
    return s * 0.22 + t * 0.78;
  };

  /* 0 before the blue chat, 1 once it has reached the can. */
  var typeLean = function () {
    if (!typeStation || reduce) return 0;
    var viewH = window.innerHeight || 1;
    var top = typeStation.getBoundingClientRect().top;
    var start = viewH * 0.9;
    var end = viewH * 0.4;
    if (top >= start) return 0;
    if (top <= end) return 1;
    return smooth((start - top) / (start - end));
  };

  /* How far the album polaroid is from the can. 1 = sitting in the frame, 0 = clear of it. */
  var dockPose = function () {
    var dock = follow.querySelector('[data-can-dock]');
    var pin = follow.querySelector('.sn-follow__pin');
    if (!dock || !pin) return null;
    var frame = dock.querySelector('.sn-follow__shot-frame') || dock;
    var natW = wrap.offsetWidth || 1;
    var natH = wrap.offsetHeight || 1;
    var pinRect = pin.getBoundingClientRect();
    var wrapCx = pinRect.left + wrap.offsetLeft + natW / 2;
    var wrapCy = pinRect.top + wrap.offsetTop + natH / 2;
    var dockRect = frame.getBoundingClientRect();
    if (dockRect.width < 8 || dockRect.height < 8) return null;
    var dockCx = dockRect.left + dockRect.width / 2;
    var dockCy = dockRect.top + dockRect.height / 2;
    var dy = dockCy - wrapCy;
    var viewH = window.innerHeight || 800;
    var mobileDock = window.matchMedia('(max-width: 899px)').matches;
    /* Phone reach stays inside the gap between the hero and the frame, so the
       purple can stays put. Leaving is a little longer than arriving. */
    var reach = mobileDock
      ? viewH * (dy >= 0 ? 0.86 : 1.08)
      : viewH * (dy >= 0 ? 0.95 : 0.82);
    var along = 1 - Math.min(1, Math.abs(dy) / reach);
    var t = mobileDock ? glide(along) : smooth(along);
    /* Size changes evenly across the whole move, so it doesn't rush in the middle. */
    var scaleReach = mobileDock ? viewH * (dy >= 0 ? 0.92 : 1.35) : reach;
    var scaleAlong = 1 - Math.min(1, Math.abs(dy) / scaleReach);
    var scaleT = mobileDock ? scaleEase(scaleAlong) : t;
    /* Drop into the frame only once it is alongside, then let go.
       A wide follow made the can ride up with the photo and fall back. */
    var seat = mobileDock ? smooth(1 - Math.min(1, Math.abs(dy) / (viewH * 0.13))) : t;
    return {
      t: t,
      scaleT: scaleT,
      seat: seat,
      tx: dockCx - wrapCx,
      ty: dy,
      scale: Math.min(dockRect.width / natW, dockRect.height / natH) * 0.9,
      rot: mobileDock ? -4 : -5.5
    };
  };

  var setHeaderClearance = function () {
    if (document.body.classList.contains('sn-nav-drawer-open')) return;
    var headerGroup = document.getElementById('header-group');
    var measured = headerGroup ? headerGroup.offsetHeight : 0;
    var px = Math.max(measured, 84) + 'px';
    document.documentElement.style.setProperty('--header-group-height', px);
    document.body.style.setProperty('--header-group-height', px);
  };

  var ticking = false;
  var shown = null;
  var update = function () {
    ticking = false;
    setHeaderClearance();
    document.body.classList.toggle('is-nav-float', window.scrollY > 10);
    syncStation();

    if (!wrap) return;

    var mobile = window.matchMedia('(max-width: 899px)').matches;
    var exit = mobile ? typeExitProgress() : 0;
    follow.style.setProperty('--sn-can-exit', exit.toFixed(3));
    follow.classList.toggle('is-can-leaving', exit > 0.02);
    follow.classList.toggle('is-can-gone', exit > 0.9);

    var busy = follow.classList.contains('is-cracked') || follow.classList.contains('is-shake');
    var pose = (!busy && exit <= 0.08) ? dockPose() : null;
    var docking = !!(pose && pose.t > 0.02);
    follow.classList.toggle('is-can-docking', docking);

    if (busy) {
      wrap.style.rotate = '';
      wrap.style.transform = '';
      wrap.style.opacity = '';
      shown = null;
      return;
    }

    var restTx = 0;
    var restTy = 0;
    var restRot = 0;
    var restScale = 1;
    if (!reduce && mobile) {
      restRot = -3;
    } else if (!reduce) {
      var rect = follow.getBoundingClientRect();
      var span = Math.max(follow.offsetHeight - window.innerHeight, 1);
      var progress = Math.min(1, Math.max(0, -rect.top / span));
      restRot = (0.4 - progress) * 6;
      restTx = Math.sin(progress * Math.PI * 1.35) * 6;
      restTy = Math.cos(progress * Math.PI * 1.7) * 2.5;
      restScale = 1 + Math.sin(progress * Math.PI) * 0.02;
    }

    var tx = restTx;
    var ty = restTy;
    var rot = restRot;
    var scale = restScale;
    var opacity = 1;
    var lean = docking ? 0 : typeLean();
    if (lean > 0) {
      /* Opposite of the resting lean, so the can tips the other way on the blue. */
      var tip = 6.5;
      rot = restRot + (tip - restRot) * lean;
      tx += (mobile ? 16 : 22) * lean;
      ty += (mobile ? -8 : -12) * lean;
    }
    if (docking) {
      var blend = pose.t;
      var seat = pose.seat != null ? pose.seat : blend;
      var scaleBlend = (mobile && pose.scaleT != null) ? pose.scaleT : blend;
      tx = restTx + (pose.tx - restTx) * blend;
      ty = restTy + (pose.ty - restTy) * seat;
      rot = restRot + (pose.rot - restRot) * blend;
      scale = restScale + (pose.scale - restScale) * scaleBlend;
    }
    if (mobile && exit > 0) {
      var viewW = window.innerWidth || 390;
      var viewH = window.innerHeight || 800;
      tx += (-viewW * 0.85 - tx) * exit;
      ty += (-viewH * 0.12 - ty) * exit;
      rot += (-28 - rot) * exit;
      scale += (0.82 - scale) * exit;
      opacity = 1 - exit;
    }

    var lag = 0;
    if (mobile && !reduce) {
      var now = performance.now();
      if (!shown) shown = { tx: tx, ty: ty, rot: rot, scale: scale, opacity: opacity, at: now };
      var dt = Math.min(40, Math.max(8, now - shown.at));
      shown.at = now;
      /* The slide stays with the finger. Size eases a little longer so it zooms
         instead of stepping. */
      var tau = docking ? 58 : 120;
      var ease = 1 - Math.exp(-dt / tau);
      var scaleEaseAmt = 1 - Math.exp(-dt / (docking ? 100 : 120));
      shown.tx += (tx - shown.tx) * ease;
      shown.ty += (ty - shown.ty) * ease;
      shown.rot += (rot - shown.rot) * ease;
      shown.scale += (scale - shown.scale) * scaleEaseAmt;
      shown.opacity += (opacity - shown.opacity) * ease;
      lag = Math.abs(tx - shown.tx) + Math.abs(ty - shown.ty) + Math.abs(rot - shown.rot) + Math.abs((scale - shown.scale) * 80) + Math.abs((opacity - shown.opacity) * 40);
      tx = shown.tx;
      ty = shown.ty;
      rot = shown.rot;
      scale = shown.scale;
      opacity = shown.opacity;
    } else {
      shown = null;
    }

    wrap.style.rotate = '';
    if (reduce && !docking && exit <= 0) {
      wrap.style.transform = '';
      wrap.style.opacity = '';
      return;
    }
    wrap.style.opacity = opacity < 0.995 ? String(opacity) : '';
    wrap.style.transform =
      'translate(' + tx.toFixed(2) + 'px, ' + ty.toFixed(2) + 'px) rotate(' +
      rot.toFixed(2) + 'deg) scale(' + scale.toFixed(4) + ')';
    if (lag > 0.8) onScroll();
  };

  var onScroll = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', update);
  setHeaderClearance();
  update();
})();
